function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.374 6.941H3.726l4.563-4.562a1.054 1.054 0 0 0 0-1.484 1.052 1.052 0 0 0-1.484 0L.48 7.219a1.046 1.046 0 0 0-.303.755l-.002.017c0 .008.005.017.005.025.003.129.027.256.076.377.031.073.084.132.131.198.034.045.052.1.093.14l6.325 6.325a1.054 1.054 0 0 0 1.484 0 1.054 1.054 0 0 0 0-1.485L3.758 9.04h11.616c.578 0 1.05-.473 1.05-1.048 0-.578-.472-1.051-1.05-1.051",
  fill: "#637280",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/back.ee988d49.svg";
export { SvgComponent as ReactComponent };